export const TAB_ITEMS = [
  { id: 'candidates', label: 'Candidates', selected: true, count: 0 },
  { id: 'jobs', label: 'Jobs', selected: false, count: 0 },
  { id: 'interviews', label: 'Interviews', selected: false, count: 0 },
  { id: 'flows', label: 'Flows', selected: false, count: 0 },
];

export const TAB_ID = {
  CANDIDATES: 'candidates',
  JOBS: 'jobs',
  INTERVIEWS: 'interviews',
  FLOWS: 'flows',
} as const;

export const VIEW = {
  RECENTLY_VIEWED: 'RECENTLY_VIEWED',
  TRIGGER: 'TRIGGER',
  RESULTS: 'RESULTS',
} as const;

export const ROUTE_MAP: Record<string, (_id: string) => string> = {
  [TAB_ID.CANDIDATES]: (_id) => `/contacts/${_id}/overview`,
  [TAB_ID.JOBS]: (_id) => `/jobs/${_id}`,
  [TAB_ID.INTERVIEWS]: (_id) => `/interviews/${_id}`,
  [TAB_ID.FLOWS]: (_id) => `/outreaches/${_id}`,
};
